import { render, staticRenderFns } from "./DetailedCustomerReceiptsReport.vue?vue&type=template&id=6667a040"
import script from "./DetailedCustomerReceiptsReport.vue?vue&type=script&lang=js"
export * from "./DetailedCustomerReceiptsReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports